import React from 'react';
import PropTypes from 'prop-types';

const CardModal = ({
    title, children, show, showClose, actions, onClose,
}) => (
    <div className={`modal ${show && 'is-active'}`}>
        <div className="modal-background" />
        <div className="modal-card">
            <header className="modal-card-head">
                <p className="modal-card-title">{title}</p>
                {
                    showClose
                    && <button type="button" className="delete" aria-label="close" onClick={onClose} />
                }
            </header>
            <section className="modal-card-body">
                {children}
            </section>
            <footer className="modal-card-foot">
                {actions}
            </footer>
        </div>
    </div>

);

CardModal.defaultProps = {
    onClose: null,
    showClose: true,
    title: '',
};

CardModal.propTypes = {
    children: PropTypes.node.isRequired,
    actions: PropTypes.node.isRequired,
    show: PropTypes.bool.isRequired,
    title: PropTypes.string,
    onClose: PropTypes.func,
    showClose: PropTypes.bool,
};

export default CardModal;
